/* tslint:disable */
/* eslint-disable */
/**
 * Bfree API
 * API Documentation for B&Free Project
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HostCollaborationHouseInput
 */
export interface HostCollaborationHouseInput {
    /**
     * 
     * @type {number}
     * @memberof HostCollaborationHouseInput
     */
    id?: number;
    /**
     * List of accommodation ids
     * @type {Array<number>}
     * @memberof HostCollaborationHouseInput
     */
    accommodations?: Array<number>;
}

export function HostCollaborationHouseInputFromJSON(json: any): HostCollaborationHouseInput {
    return HostCollaborationHouseInputFromJSONTyped(json, false);
}

export function HostCollaborationHouseInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): HostCollaborationHouseInput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'accommodations': !exists(json, 'accommodations') ? undefined : json['accommodations'],
    };
}

export function HostCollaborationHouseInputToJSON(value?: HostCollaborationHouseInput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'accommodations': value.accommodations,
    };
}

